/**
 * Web Style Import
 *
 */

import './style/dnb-input-masked.scss'
